// extracted by mini-css-extract-plugin
export default {"remainingTime":"YF0gG","time":"NrjZQ"};